import React, { useState } from 'react';
import { FiLogOut, FiSun, FiMoon, FiMenu, FiLock } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../services/auth';
import { useCurrentAdmin } from '../../hooks/useCurrentAdmin';
import { useTheme } from '../../hooks/useTheme';
import { version } from '../../config/version';
import ChangePasswordModal from '../backoffice/ChangePasswordModal';

interface TopBarProps {
  onMenuToggle?: () => void;
  showMenuButton?: boolean;
}

const TopBar: React.FC<TopBarProps> = ({ onMenuToggle, showMenuButton }) => {
  const navigate = useNavigate();
  const { admin } = useCurrentAdmin();
  const { resolvedTheme, setTheme } = useTheme();
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const toggleTheme = () => {
    setTheme(resolvedTheme === 'dark' ? 'light' : 'dark');
  };

  return (
    <header className="sticky top-0 z-30 bg-surface border-b border-border">
      <div className="flex items-center justify-between h-14 px-4">
        <div className="flex items-center gap-3">
          {showMenuButton && (
            <button onClick={onMenuToggle} className="p-2 rounded-lg text-content-secondary hover:bg-surface-tertiary transition-colors lg:hidden">
              <FiMenu className="w-5 h-5" />
            </button>
          )}
          <div className="hidden sm:block">
            <span className="text-sm font-semibold text-content-primary">Backoffice Estrada</span>
            <span className="ml-2 text-xs text-content-tertiary font-mono">v{version}</span>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <button
            onClick={toggleTheme}
            className="p-2 rounded-lg text-content-secondary hover:bg-surface-tertiary transition-colors"
            title={resolvedTheme === 'dark' ? 'Modo claro' : 'Modo oscuro'}
          >
            {resolvedTheme === 'dark' ? <FiSun className="w-4 h-4" /> : <FiMoon className="w-4 h-4" />}
          </button>
          <span className="hidden sm:inline text-sm text-content-secondary">{admin?.username}</span>
          <button onClick={() => setShowPasswordModal(true)} className="p-2 rounded-lg text-content-secondary hover:bg-surface-tertiary transition-colors" title="Cambiar contraseña">
            <FiLock className="w-4 h-4" />
          </button>
          <button onClick={handleLogout} className="p-2 rounded-lg text-danger-600 hover:bg-danger-50 transition-colors" title="Cerrar sesion">
            <FiLogOut className="w-4 h-4" />
          </button>
        </div>
      </div>

      <ChangePasswordModal isOpen={showPasswordModal} onClose={() => setShowPasswordModal(false)} />
    </header>
  );
};

export default TopBar;
